
export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
}
